import { defaultCountryIsoCode } from '@/plans/ZOOM_PHONE/helper/constants';
import { nStorage } from '@/common/NStorage';
import { safeJSONParse } from '@/utils';

export const getDefaultLocalSearchForm = () => {
  return {
    countryIsoCode: defaultCountryIsoCode,
    areaCode: '',
  }
}

export const getDefaultTollFreeSearchForm = () => {
  return {
    countryIsoCode: defaultCountryIsoCode,
    selectTfPrefix: "",
    vanitySuffix: '',
  }
}

export const localNumberStore = {
  state: {
    searchForm: getDefaultLocalSearchForm(),
    cachePhoneNumberList: [],
    phoneNumberList: [],
    pickedNumberList: [],
    searchTimes: 0,
    loading: false,
    showNumberList: true,
  }
};

export const tollFreeNumberStore = {
  state: {
    searchForm: getDefaultTollFreeSearchForm(),
    cachePhoneNumberList: [],
    phoneNumberList: [],
    pickedNumberList: [],
    searchTimes: 0,
    loading: false,
    showNumberList: true,
  }
};

export const phoneNumberStorage = {
  NumberStateKey: '_phone_number_cache_' + nStorage.namespace,
  store({
    localNumberState,
    tollFreeNumberState,
    portNumberList,
  }) {
    nStorage.setItem(this.NumberStateKey, JSON.stringify({
      localNumberState: localNumberState,
      tollFreeNumberState: tollFreeNumberState,
      portNumberList: portNumberList,
    }));
  },
  getState() {
    return safeJSONParse(nStorage.getItem(this.NumberStateKey), null);
  },
  update(key, value) {
    const storeState = this.getState();
    if(storeState) {
      storeState[key] = value;
      this.store(storeState);
    }
  },
  remove() {
    nStorage.removeItem(this.NumberStateKey);
  },
};
